module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2_m_en.f8170b5165fb65929a2dc6c463e6e55c.png";